import React from "react";
import {
  FooterSection,
  NovartisFooter,
} from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/footer";
import { useFooter } from "@nvs/gatsby-theme-leap-core/src/hooks";

export interface FooterProps {
  mlrVersion: string;
}
function Footer({ mlrVersion }: FooterProps) {
  const config = useFooter();
  return (
    <footer
      className={config.className || "bg-neutral"}
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="flex flex-col">
        <FooterSection className={config.novartisFooter.className}>
          <NovartisFooter
            mlrVersion={mlrVersion}
            config={config.novartisFooter}
          />
        </FooterSection>
      </div>
    </footer>
  );
}

export default Footer;
